<template>
  <div class="page-skills">
    <h2>SKILLS</h2>
    <p>html css javascript ruby Ruby on Rails </p>
    <p>mysql sqlite </p>
    <p>iOS swift</p>
    <p>c++ c# python</p>
    <p v-for="c in content"> {{ c }} </p>
    <!-- <div class="detail_button"> <p>show details</p> </div> -->
  </div>
</template>


<script>

export default {
  name: 'Skils',
  data() {
    return {
      content: [
        ""
      ]
    }
  }
}

</script>

<style>

.page-skills {
  height: 300px;
  /* background-color: red; */
  text-align: center;
}

/* page-skills classを指定したdivタグの子要素のpタグに適応 */
div.page-skills p {
  font-size: 18px;
  color: darkgray;
}

div.page-skills h2 {
  color: pink;
}

</style>



// WEBPACK FOOTER //
// src/pages/Skills.vue